import { makeStyles, Theme } from '@material-ui/core';

export const useWalletCardStyles = makeStyles<Theme>(theme => ({
  root: {
    minWidth: 220,
    maxWidth: 400,
    borderRadius: 4,
    backgroundColor: '#fff',
    padding: theme.spacing(1.5, 2, 0.5),
    border: '1px solid #333',
    boxShadow: '4.639px 4.639px 0px 0px #D2D2F9',
  },
  row: {
    padding: theme.spacing(0.5, 0),
  },
  name: {
    fontSize: 22,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
  },
  walletBalance: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    fontSize: 14,
    fontWeight: 500,
  },
  walletLogo: {
    marginRight: theme.spacing(1),
    width: 24,
    height: 24,
    verticalAlign: 'middle',
  },
  menuList: {
    borderTop: '1px solid #eee',
    margin: theme.spacing(1.5, -2, 0),
  },
  menuItem: {
    fontSize: 14,
    fontWeight: 500,
    color: '#1B1B1B',
    padding: theme.spacing(1.25, 2),
    '&:hover': {
      backgroundColor: '#f5f5ff',
      color: '#1C1CFF',
    },
  },
}));
